function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.54565 2L11.0002 4.4L11.0001 4.40009L12.43 5.79823L18.57 11.8018L20 13.2L18.57 14.5982L12.43 20.6018L11 22L9.56999 20.6018L3.43001 14.5982L2 13.2L3.43001 11.8018L9.36373 5.9999L6.90929 3.6L8.54565 2ZM16.7767 12.8448L11 7.19646L5.2233 12.8448H16.7767Z",
  fill: ""
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 2,
  fill: ""
});

var SvgPalette = function SvgPalette(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#220C4A",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPalette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/palette.df42438e.svg";
export { ForwardRef as ReactComponent };